import React, { useEffect, useState } from "react";
import { SingleCardMetric } from "../ui/SingleCardMetric";

interface ShelterExitDayTypeMetricState {
  data: any;
  setSelectedData: (data: any[] | null) => void;
  readOnly?: boolean;
  active: boolean;
  exitType: string;
  onHandleClick?: any;
}

export const ShelterExitDayTypeMetric = ({
  data,
  setSelectedData,
  readOnly = true,
  active,
  exitType,
  onHandleClick,
}: ShelterExitDayTypeMetricState) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [dayRange, setDateRange] = useState<number>(7);
  const [current, setCurrent] = useState<string>();
  const [currentData, setCurrentData] = useState<any[]>();

  useEffect(() => {
    if (data) {
      const { intakes, start } = data;
      let range = 7;
      if (start) {
        range = getDayRangeFromStartDate(start);
        setDateRange(range);
      }
      const recent = intakes.filter((item: any) => isWithinLastXDays(item, range + 1) && item.exit_type === exitType);
      const recentCount = recent.length.toString();
      setCurrent(recentCount);
      setCurrentData(recent);
    }
    setIsLoading(false);
  }, [data]);

  function getDayRangeFromStartDate(start: string): number {
    const today = new Date();
    today?.setHours(0, 0, 0, 0);
    const startDate = new Date(start);
    startDate?.setHours(0, 0, 0, 0);
    const dayRangeTime: number = today.getTime() - startDate.getTime();
    return Math.ceil(dayRangeTime / (1000 * 60 * 60 * 24)) - 1;
  }

  function isWithinLastXDays(item: any, dayRange: number) {
    const today = new Date();
    const exitDate = new Date(item.exit_at);
    today.setHours(0, 0, 0, 0);
    exitDate.setHours(0, 0, 0, 0);

    const diffInTime: number = today.getTime() - exitDate.getTime();
    const diffInDays = diffInTime / (1000 * 60 * 60 * 24);

    return diffInDays >= 0 && diffInDays <= dayRange; // 7 days + today
  }

  const onViewDetails = () => {
    if (!active) {
      setSelectedData(currentData || null);
    } else {
      setSelectedData(null);
    }

    onHandleClick();
  };

  if (readOnly) {
    return (
      <SingleCardMetric
        title={`Exits Last ${dayRange} Days (${exitType.charAt(0).toUpperCase() + String(exitType).slice(1)})`}
        total={current}
        isLoading={isLoading}
      />
    );
  } else {
    return (
      <SingleCardMetric
        title={`Exits Last ${dayRange} Days (${exitType.charAt(0).toUpperCase() + String(exitType).slice(1)})`}
        total={current}
        onHandleClick={onViewDetails}
        cursor={true}
        active={active}
        isLoading={isLoading}
      />
    );
  }
};
